/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
import { useEffect, useMemo, useState } from "react";
import { matchAgenciaFilter } from "../..";
import {
  calcularImporteNetoIntermediario,
  calcularPorcentajeComisionIntermediario,
  getConvertedImporte,
} from "../../../utils";

export const useVFFiltering = ({
  todasOportunidades,
  intermediarios,
  clientes,
  usuarios,
  pais,
  resolverNombreIntermediario,
  getRateForOportunidad,
  getDolarRateForDate,
  siiMap,
}) => {
  const [oportunidadesFiltradas, setOportunidadesFiltradas] = useState([]);
  const [filtroNumeroFactura, setFiltroNumeroFactura] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCobrada, setFiltroCobrada] = useState("");
  const [numerosFacturaUnicos, setNumerosFacturaUnicos] = useState([]);
  const [clientesUnicos, setClientesUnicos] = useState([]);
  const [filtroAnos, setFiltroAnos] = useState([new Date().getFullYear().toString()]);
  const [filtroMeses, setFiltroMeses] = useState([String(new Date().getMonth() + 1).padStart(2, "0")]);
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroModalidad, setFiltroModalidad] = useState("");
  const [porcentajesVertical, setPorcentajesVertical] = useState({
    publicidad: 0, hardware: 0, gestion: 0, btl: 0,
  });
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroFacturado, setFiltroFacturado] = useState("");
  const [filtroMoneda, setFiltroMoneda] = useState("LOCAL");
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");

  useEffect(() => {
    const filtrarOportunidades = () => {
      // Filtrado base (sin filtro de tipo) para calcular % por vertical
      const filtradasBase = todasOportunidades.filter((oportunidad) => {
        // Parseo manual del string para evitar shift de timezone (ej: "2026-04-01" en UTC-5
        // se interpretaría como 2026-03-31 si se pasa a `new Date()`).
        const facturafechaParts = oportunidad.facturafecha
          ? oportunidad.facturafecha.split("T")[0].split("-")
          : null;
        const mesFactura = facturafechaParts ? facturafechaParts[1] : null;
        const anoFactura = facturafechaParts ? parseInt(facturafechaParts[0], 10) : null;
        const mesOportunidad = oportunidad.mes ? oportunidad.mes.toString().padStart(2, "0") : null;
        const anoOportunidad = oportunidad.ano ? parseInt(oportunidad.ano, 10) : null;
        const mesParaFiltrar = mesFactura || mesOportunidad;
        const anoParaFiltrar = anoFactura || anoOportunidad;
        const mesFiltrado = filtroMeses.length > 0
          ? (mesParaFiltrar ? filtroMeses.includes(mesParaFiltrar) : false) : true;
        const clienteAsociado = clientes.find((c) => c.id === oportunidad.client_id);
        const intermediarioId = clienteAsociado ? clienteAsociado.agencia : null;
        const intermediarioFiltrado = matchAgenciaFilter(filtroIntermediario, intermediarioId, pais);
        const tieneFactura = (() => {
          if (oportunidad.facturanumero && oportunidad.facturanumero.trim() !== "") return true;
          if (!siiMap?._byRef) return false;
          // Verificar vinculación SII por concepto
          let refKey = null;
          if (oportunidad.negocio_id && oportunidad.sii_ref_index != null) {
            refKey = `negocios_carteleria:${oportunidad.negocio_id}:${oportunidad.sii_ref_index}`;
          } else if (oportunidad.type === "pauta") {
            refKey = `sales:${oportunidad.id}:`;
          } else if (oportunidad.type === "BTL") {
            refKey = `sales_btl:${oportunidad.id}:`;
          } else if (oportunidad.type === "contrato") {
            refKey = `sales_contratos:${oportunidad.contrato_id}:${oportunidad.mes_index ?? ""}`;
          }
          return refKey ? !!siiMap._byRef[refKey] : false;
        })();
        const facturadoFiltrado = filtroFacturado
          ? filtroFacturado === "Facturado"
            ? tieneFactura
            : !tieneFactura
          : true;
        const perteneceAlAno = filtroAnos.length > 0 ? filtroAnos.includes(anoParaFiltrar?.toString()) : true;
        const ejecutivoFiltrado = filtroEjecutivo
          ? oportunidad.ejecutivo === parseInt(filtroEjecutivo, 10)
          : true;
        return (
          mesFiltrado &&
          intermediarioFiltrado &&
          (filtroNumeroFactura ? oportunidad._displayFolio === filtroNumeroFactura : true) &&
          (filtroCliente ? oportunidad.cliente === filtroCliente : true) &&
          (filtroCobrada
            ? filtroCobrada === "Sí"
              ? oportunidad.facturafechacobro
              : !oportunidad.facturafechacobro
            : true) &&
          facturadoFiltrado &&
          perteneceAlAno &&
          ejecutivoFiltrado &&
          oportunidad.estatus === "100%" &&
          !oportunidad.eliminada
        );
      });

      // Calcular % por vertical sobre filtradasBase
      const totalesVert = { publicidad: 0, hardware: 0, gestion: 0, btl: 0 };
      filtradasBase.forEach((o) => {
        const imp = parseFloat(o.importe) || 0;
        if (["pauta", "contrato"].includes(o.type)) totalesVert.publicidad += imp;
        else if (["HW-CAPEX", "HW-OPEX"].includes(o.type)) totalesVert.hardware += imp;
        else if (o.type === "Gestión") totalesVert.gestion += imp;
        else if (o.type === "BTL") totalesVert.btl += imp;
      });
      const totalGeneral = totalesVert.publicidad + totalesVert.hardware + totalesVert.gestion + totalesVert.btl;
      setPorcentajesVertical({
        publicidad: totalGeneral > 0 ? Math.round((totalesVert.publicidad / totalGeneral) * 100) : 0,
        hardware: totalGeneral > 0 ? Math.round((totalesVert.hardware / totalGeneral) * 100) : 0,
        gestion: totalGeneral > 0 ? Math.round((totalesVert.gestion / totalGeneral) * 100) : 0,
        btl: totalGeneral > 0 ? Math.round((totalesVert.btl / totalGeneral) * 100) : 0,
      });

      // Aplicar filtro de tipo
      const filtradas = filtradasBase
        .filter((oportunidad) => {
          if (filtroTipo === "publicidad") return ["pauta", "contrato"].includes(oportunidad.type);
          if (filtroTipo === "hardware") {
            if (filtroModalidad === "CAPEX") return oportunidad.type === "HW-CAPEX";
            if (filtroModalidad === "OPEX") return oportunidad.type === "HW-OPEX";
            return ["HW-CAPEX", "HW-OPEX"].includes(oportunidad.type);
          }
          if (filtroTipo === "Gestión") return oportunidad.type === "Gestión";
          if (filtroTipo === "BTL") return oportunidad.type === "BTL";
          return true;
        })
        .map((oportunidad) => {
          let comision = oportunidad.comision;
          const esCarteleria = ["HW-CAPEX", "HW-OPEX", "Gestión"].includes(oportunidad.type);
          let intermediarioNombre = (oportunidad.type === "BTL" || esCarteleria) ? "DIRECTO" : null;
          const ejecutivoAsociado = usuarios.find((u) => parseInt(u.id, 10) === oportunidad.ejecutivo);
          const ejecutivoNombre = ejecutivoAsociado
            ? ejecutivoAsociado.nombre
            : "??";
          if (oportunidad.type !== "BTL" && !esCarteleria) {
            const clienteAsociado = clientes.find((c) => c.id === oportunidad.client_id);
            const intermediarioId = clienteAsociado ? clienteAsociado.agencia : null;
            // Decisión B: el nombre sigue mostrando la agencia real (no el override OMNET).
            intermediarioNombre = resolverNombreIntermediario(intermediarioId, intermediarios);
            // El % de intermediación se delega al motor canónico, que resuelve
            // intermediario_override_id, la ventana comision/comision_2 y la fecha
            // (resolverFechaFactura). Antes se calculaba inline y esquivaba el override.
            comision = calcularPorcentajeComisionIntermediario(oportunidad, clientes, intermediarios, pais);
          }
          return {
            ...oportunidad,
            intermediario: intermediarioNombre,
            comision,
            moneda_dolar: oportunidad.moneda_dolar || false,
            ejecutivoNombre,
            ano: oportunidad.ano ? oportunidad.ano.toString() : new Date().getFullYear().toString(),
          };
        });
      const filtradasOrdenadas = filtradas.sort((a, b) => {
        // 1) Sin facturar primero, facturados después
        const hasFactA = a.facturanumero ? 1 : 0;
        const hasFactB = b.facturanumero ? 1 : 0;
        if (hasFactA !== hasFactB) return hasFactA - hasFactB;
        // 2) Dentro de pendientes: importe normalizado a moneda local, descendente
        if (!a.facturanumero && !b.facturanumero) {
          const impA = getConvertedImporte(a, getRateForOportunidad(a)) || 0;
          const impB = getConvertedImporte(b, getRateForOportunidad(b)) || 0;
          return impB - impA;
        }
        // 3) Dentro de facturados: por número de factura ascendente
        return (a.facturanumero || "").localeCompare(b.facturanumero || "", undefined, { numeric: true });
      });
      setOportunidadesFiltradas(filtradasOrdenadas);
      const numerosFactura = [...new Set(
        todasOportunidades
          .filter((o) => filtroAnos.length === 0 || filtroAnos.includes(String(o.ano)))
          .map((o) => o._displayFolio)
      )]
        .filter(Boolean)
        .sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));
      setNumerosFacturaUnicos(numerosFactura);
      const clientesUnicosList = [...new Set(filtradasOrdenadas.map((o) => o.cliente))].filter(Boolean).sort();
      setClientesUnicos(clientesUnicosList);
    };
    if (todasOportunidades.length > 0 && clientes.length > 0 && intermediarios.length > 0 && usuarios.length > 0) {
      filtrarOportunidades();
    }
  }, [
    filtroMeses,
    filtroNumeroFactura,
    filtroCliente,
    filtroCobrada,
    filtroFacturado,
    filtroAnos,
    filtroIntermediario,
    filtroTipo,
    filtroModalidad,
    filtroEjecutivo,
    todasOportunidades,
    intermediarios,
    clientes,
    usuarios,
    resolverNombreIntermediario,
    pais,
    siiMap,
  ]);

  const handleMesChange = (mes) => {
    setFiltroMeses((prev) =>
      prev.includes(mes) ? prev.filter((item) => item !== mes) : [...prev, mes]
    );
  };

  const handleAnoChange = (ano) => {
    setFiltroAnos((prev) =>
      prev.includes(ano) ? prev.filter((item) => item !== ano) : [...prev, ano]
    );
  };

  const totales = useMemo(() => {
    let totalVenta = 0;
    let totalComisionIntermediario = 0;
    let totalNeto = 0;
    let totalCobrado = 0;
    let totalFacturado = 0;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    oportunidadesFiltradas.forEach((oportunidad) => {
      const importeLocal = getConvertedImporte(oportunidad, getRateForOportunidad(oportunidad));
      const dolarRate = getDolarRateForDate(oportunidad.facturafecha);
      const importeDisplay = filtroMoneda === "USD" ? importeLocal / dolarRate : importeLocal;
      totalVenta += importeDisplay;

      const netoLocal = calcularImporteNetoIntermediario(
        { ...oportunidad, importe: importeLocal },
        Object.values(clientes),
        Object.values(intermediarios),
        pais
      );
      const comisionLocal = importeLocal - netoLocal;
      const comisionDisplay = filtroMoneda === "USD" ? comisionLocal / dolarRate : comisionLocal;
      totalComisionIntermediario += comisionDisplay;

      // Sumar a facturado si tiene número de factura
      if (oportunidad.facturanumero) {
        totalFacturado += importeDisplay;
      }

      if (oportunidad.facturafechacobro) {
        const fechaCobro = new Date(oportunidad.facturafechacobro);
        fechaCobro.setHours(0, 0, 0, 0);
        if (fechaCobro <= hoy) {
          totalCobrado += importeDisplay;
        }
      }
    });

    totalNeto = totalVenta - totalComisionIntermediario;

    // Calcular porcentaje facturado
    const porcentajeFacturado = totalVenta > 0 ? (totalFacturado / totalVenta) * 100 : 0;

    return {
      totalVenta,
      totalComisionIntermediario,
      totalNeto,
      totalCobrado,
      totalFacturado,
      porcentajeFacturado,
    };
  }, [oportunidadesFiltradas, filtroMoneda, getRateForOportunidad, getDolarRateForDate, clientes, intermediarios, pais]);

  return {
    // Filter values + setters
    filtroNumeroFactura, setFiltroNumeroFactura,
    filtroCliente, setFiltroCliente,
    filtroCobrada, setFiltroCobrada,
    filtroAnos, setFiltroAnos,
    filtroMeses, setFiltroMeses,
    filtroTipo, setFiltroTipo,
    filtroModalidad, setFiltroModalidad,
    filtroIntermediario, setFiltroIntermediario,
    filtroFacturado, setFiltroFacturado,
    filtroMoneda, setFiltroMoneda,
    filtroEjecutivo, setFiltroEjecutivo,
    // Derived
    oportunidadesFiltradas,
    porcentajesVertical,
    numerosFacturaUnicos,
    clientesUnicos,
    // Handlers
    handleMesChange,
    handleAnoChange,
    // Computed totals
    totales,
  };
};
